import { registerSW } from 'virtual:pwa-register';

// Create and show update toast notification
function showUpdateToast() {
  // Remove any existing toast
  const existing = document.getElementById('pwa-update-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.id = 'pwa-update-toast';
  toast.innerHTML = `
    <div style="
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(135deg, #6366f1, #8b5cf6);
      color: white;
      padding: 16px 24px;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(99, 102, 241, 0.4);
      z-index: 999999;
      display: flex;
      align-items: center;
      gap: 12px;
      font-family: system-ui, -apple-system, sans-serif;
      font-size: 14px;
      font-weight: 500;
      animation: slideDown 0.3s ease-out;
    ">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;">
        <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
      </svg>
      <span>מעדכן גרסה חדשה...</span>
    </div>
    <style>
      @keyframes slideDown {
        from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
        to { opacity: 1; transform: translateX(-50%) translateY(0); }
      }
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    </style>
  `;
  document.body.appendChild(toast);
}

export function registerServiceWorker() {
  const updateSW = registerSW({
    onNeedRefresh() {
      console.log('New version available! Auto-updating...');

      // Show update notification
      showUpdateToast();

      // Auto-update after a brief delay to show the notification
      setTimeout(() => {
        updateSW(true);
      }, 1000);
    },
    onOfflineReady() {
      console.log('App is ready to work offline!');
    },
    onRegistered(r: ServiceWorkerRegistration | undefined) {
      console.log('Service worker registered:', r);

      // Check for updates every 5 minutes for faster updates
      if (r) {
        setInterval(
          () => {
            r.update();
          },
          5 * 60 * 1000
        );
      }
    },
    onRegisterError(error: unknown) {
      console.error('Service worker registration error:', error);
    },
  });

  return updateSW;
}
